import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { urlParams, getPageLayoutType, decode_utf8, validateEmailFunc, validateCell, getSignedIdStatus, transformId } from '../../../../common/utils/utilsFunc'
import SubscriptionsContextProvider, { ACTIONS, SubscriptionsContext } from '../../context/SubscriptionsContextProvider';
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import "../../styles/index.scss"
import Loading from "../../../../common/components/Loading";
import FormsModificationSuscription from '../FormsModificationSuscription';
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function ModificationSubscriptions({ props }) {
    const [state, dispatch] = React.useContext(SubscriptionsContext)
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [secondStep, setSecondSetp] = React.useState(false)
    const [visibleModalEmail, setVisibleModalEmail] = React.useState(false);
    const [visibleModalReturn, setVisibleModalReturn] = React.useState(false);
    const [msgModalReturn, setMsgModalReturn] = React.useState(false);
    const [errorCli, setErrorCli] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModalEmail(false);
            setVisibleModalReturn(false)
        },
    });
    const [values, setValues] = React.useState({
        idClient: '',
        email: ''
    })
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });

    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);


    function setInitialStateForms() {
        setValues({
            idClient: getPageLayoutType() ? values.idClient : '',
            email: '',
            newEmail: '',
            newEmailConfirm: '',
            newCellphone: '',
        })
        if(props?.detailClientJson?.COMUNA) {
            props?.setDetailClientJson([]);
        }
        setInputValidate({
            empty: {},
            error: {},
            msg: {}
        });
    }

    let propsLabelInfoContent = {
        "setVisibleModal": setVisibleModal,
        "observer": observer,
        "onClose": onClose,
        "visibleModal": visibleModal,
        "titleModal": "Información",
        "status": "info",
        "content": state?.webContentTextInfo,
        "titleHint": "Ayuda Nro de Cliente",

    }

    let propsLabelInfoContentEmail = {
        "setVisibleModal": setVisibleModalEmail,
        "observer": observer,
        "onClose": onClose,
        "visibleModal": visibleModalEmail,
        "titleModal": "Información",
        "status": "info",
        "content": state?.webContentModificationSubscriptionEmail,
        "titleHint": "Información",
    }

    React.useEffect(() => {
        let canal = urlParams.get('canal')
        let ctacto = urlParams.get('ctacto')
        if (canal) {
            setValues({ ...values, canal: canal, idClient: ctacto })
        } else if (getPageLayoutType()) {
            setValues({ ...values, canal: "OV", idClient: ctacto })
        } else if (!getPageLayoutType()) {
            setValues({ ...values, canal: "URL", idClient: ctacto })
        } else {
            setValues({ ...values, canal: "", idClient: ctacto })
        }
    }, [])

    function handleClickButtonClient() {
        if (values.idClient) {
            setErrorCli(false);
            props.setIdClient(values.idClient)
        } else {
            setErrorCli(true);
        }
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function funcClickBack() {
        if(secondStep){
            setSecondSetp(false);
            setInitialStateForms();
        }else {
            window.location.href = getPageLayoutType() ? `/group/guest/suscripciones` : '/servicios-en-linea'
            
        }
    }

    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.idClient) {
            errors.empty.idClient = false;
        } else {
            errors.empty.idClient = true;
            errors.msg.idClient = "Debe ingresar un Nro de Cliente"
        }

        if (values.email) {
            errors.empty.email = false;
            if (values.email && !validateEmailFunc(values.email)) {
                errors.validated.email = true;
                errors.msg.email = "Debe ingresar el Correo Electrónico válido"
            } else {
                errors.validated.email = false;
            }
        } else {
            errors.empty.email = true;
            errors.msg.email = "Debe ingresar el Correo Electrónico"
        }

        if (values.newEmail && secondStep) {
            errors.empty.newEmail = false;
            if (values.newEmailConfirm && secondStep) {
                errors.empty.newEmailConfirm = false;
                if (values.newEmailConfirm && !validateEmailFunc(values.newEmailConfirm)) {
                    errors.validated.newEmailConfirm = true;
                    errors.msg.newEmailConfirm = "Debe ingresar un Nuevo Correo Electrónico válido"
                } else if (values.newEmailConfirm !== values.newEmail) {
                    errors.validated.newEmailConfirm = true;
                    errors.msg.newEmailConfirm = "Los Correos Electrónicos no coinciden"
                } else {
                    errors.validated.newEmailConfirm = false;
                }
            } else if (!values.newEmailConfirm && secondStep) {
                errors.empty.newEmailConfirm = true;
                errors.msg.newEmailConfirm = "Debe ingresar la confirmación del Nuevo Correo Electrónico"
            }
            if (values.newEmail && !validateEmailFunc(values.newEmail)) {
                errors.validated.newEmail = true;
                errors.msg.newEmail = "Debe ingresar un Nuevo Correo Electrónico válido"
            } else {
                errors.validated.newEmail = false;
            }
        }

        if (validateCell(values.newCellphone) && secondStep) {
            errors.validated.newCellphone = true;
            errors.msg.newCellphone = "El Número de Celular del no debe tener 9 dígitos"
        } else {
            errors.validated.newCellphone = false;
        }

        setInputValidate(errors)
        return errors
    }

    function funcClick() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning");
        } else if (!verifReCaptcha && !getPageLayoutType()) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");

        } else if ((transformId(props.state?.idClientAux) !== transformId(values.idClient)) && !getPageLayoutType()) {
            props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.","warning");
        } 
        else {
            if (!secondStep) {
                let json = {
                    "nroCliente": values.idClient,
                    "email": values.email,
                    "empresa": props.codigo_empresa,
                    "url": props.url_ws_empresa,
                }
                setLoading(true)
                dispatch({
                    type: ACTIONS.SET_JSON_VERIFICATE_MODIFICATION_SUBSCRIPTION,
                    payload: json

                })
            } else {
                if(!values.newEmail && !values.newCellphone){
                    props.setGlobalAlert("Debes ingresar al menos un dato para modificar.","warning");

                }else {
                    let json = {
                        "correoContentName": decode_utf8(props.correo_content_name_modificacion_subscription),
                        "email": values.newEmail ? values.newEmail : values.email,
                        "changedEmail":values.newEmail ? true : false,
                        "nroCliente": values.idClient,
                        "oldMail": values.email,
                        "empresa": props.codigo_empresa,
                        "url": props.url_ws_empresa,
                        "canal": values.canal,
                        "paginaConfirmacion": props.pagination_confirmation_modificacion_subscription,
                        "phone": values.newCellphone ? values.newCellphone : "",
                        "signedIn": getSignedIdStatus(),
                        "textoRetorno": values.textReturn ? values.textReturn : "",
                        // eslint-disable-next-line no-undef
                        "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
                        "claveParam": props.claveParam? props.claveParam : ''
                    }
                    dispatch({
                        type: ACTIONS.SET_JSON_MODIFICATION_SUBSCRIPTION,
                        payload: json
    
                    })
                    setLoading(true)
                }
             
            }
        }

    }

    React.useEffect(() => {
        if (state.responseModificationSubscription) {
            setLoading(false)
            if (state.responseVerificateModificationSubscription?.code || state.responseVerificateModificationSubscription?.code === 0) {
                if (state.responseModificationSubscription?.code === 0) {
                    setVisibleModalReturn(true)
                    setMsgModalReturn(state.responseModificationSubscription?.message)
                    setInitialStateForms();
                    if(secondStep){
                        setSecondSetp(false);
                    }

                } else {
                    props.setGlobalAlert(state.responseModificationSubscription?.message, "warning", true, "Advertencia");
                    dispatch({
                        type: ACTIONS.SET_JSON_MODIFICATION_SUBSCRIPTION,
                        payload: ''
                    })
                }

            } else {
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                dispatch({
                    type: ACTIONS.SET_JSON_MODIFICATION_SUBSCRIPTION,
                    payload: ''

                })
            }
        }

    }, [state.responseModificationSubscription])


    React.useEffect(() => {
        if (state.responseVerificateModificationSubscription) {
            
            setLoading(false)
            if (state.responseModificationSubscription?.code || state.responseVerificateModificationSubscription?.code === 0) {
                if (state.responseVerificateModificationSubscription?.code === 0) {
                    setSecondSetp(true)
                    setValues({ ...values, textReturn: state.responseModificationSubscription?.message })
                } else {
                    props.setGlobalAlert(state.responseVerificateModificationSubscription?.message ? state.responseModificationSubscription?.message : props.text_fetch_error, "warning", true, "Advertencia");
                    dispatch({
                        type: ACTIONS.SET_JSON_VERIFICATE_MODIFICATION_SUBSCRIPTION,
                        payload: ''
    
                    })
                }

            } else {
                props.setGlobalAlert(state.responseVerificateModificationSubscription?.message ? state.responseVerificateModificationSubscription?.message : props.text_fetch_error, "warning", true, "Advertencia");
                dispatch({
                    type: ACTIONS.SET_JSON_VERIFICATE_MODIFICATION_SUBSCRIPTION,
                    payload: ''

                })
            }
            
        }
    }, [state.responseVerificateModificationSubscription])

    return (
        <CGE.Panel title={decode_utf8(props.title_modification_subscription)} description={getPageLayoutType() ? decode_utf8(props.description_modification_anulation_subscription) : decode_utf8(props.description_modification_pub)}>
            <div className="row">
                <div className="col-md-12">
                    <CGE.DetailClient
                        props={{
                            handleChange: (e) => {
                                setValues({ ...values, idClient: e.target.value });
                                props.setDetailClientJson([]);
                            },
                            handleClick: () => { handleClickButtonClient() },
                            hasError: (errorCli || inputValidate?.empty?.idClient),
                            msgError: "Debe ingresar un Nro de Cliente",
                            idClient: values.idClient,
                            idFormElement: "inputNumClient",
                            labelButton: "Buscar",
                            labelName: "Número de Cliente",
                            mandatoryElement: true,
                            readOnly: getPageLayoutType() ? true : false,
                            sizeButton: "sm",
                            typeButton: "primary",
                            disabledButton: secondStep,
                            typeFormElement: "text",
                            typeElement:"input-mask",
                            maxLength:"12",
                            formatChars:{
                                9: "[0-9]"
                            },
                            mask:"999999999999",
                            valuePriv: values.idClient,
                            valuePub: values.idClient,
                            propsLabelInfoContent:propsLabelInfoContent,
                            disabled: secondStep
                        }}
                        propsDetail={{
                            fullNameClient: "",
                            comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                            calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                            nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                            dptoBlockClient: (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO) ? `${props.detailClientJson?.SUPLEMENTO} 
                        ${props.detailClientJson?.PISO}` : "",
                            ctaCtoClient: props.detailClientJson?.CTA_CTO
                        }}
                    />
                </div>
                <div class="col-md-6">
                    <CGE.FormsField
                        propsLabelInfoContent={propsLabelInfoContentEmail}
                        labelName="Correo electrónico"
                        idFormElement="email"
                        handleChange={(e) => setValues({ ...values, email: e.target.value })}
                        typeFormElement="text"
                        typeElement="input"
                        value={values.email}
                        mandatoryElement={true}
                        hasError={inputValidate?.empty?.email || inputValidate?.validated?.email}
                        msgError={inputValidate?.msg?.email}
                        disabled={secondStep}

                    />
                </div>
                {secondStep &&
                    <FormsModificationSuscription
                        props={{ ...props, values, setValues, setInputValidate, inputValidate }}
                    />
                }
                {!getPageLayoutType() &&
                    <div className="col-md-12">
                        <CGE.FieldRecaptcha
                            onChange={onChangeReCaptcha}
                            sitekey={props.api_key_recaptcha}
                        />
                    </div>
                }
                <div class="col-md-12">
                    <div className="d-flex justify-content-between">
                        <CGE.Button
                            className="mr-3"
                            label="Volver"
                            onClick={() => funcClickBack()}
                            type="secondary"
                        />
                        <CGE.Button
                            label="Aceptar"
                            onClick={() => funcClick()}
                        />
                    </div>
                </div>
            </div>
            {visibleModalReturn && (
                <AlertModal
                    titleModal="Información"
                    msgModal={msgModalReturn}
                    observer={observer}
                    onClose={onClose}
                    status="info"
                    labelBtnConfirm={"Ok"}
                />
            )}
            {loading && <Loading />}
        </CGE.Panel>
    )
}

const ModificationSubscriptionsWithProvider = ({
    props

}) => (
    <SubscriptionsContextProvider>
        <ModificationSubscriptions
            props={props}
        />
    </SubscriptionsContextProvider>
);

export default ModificationSubscriptionsWithProvider;